import "./products.css";
import ductsImg from "./static/ducts.png";
import bendsImg from "./static/bends.png";
import squareToRoundsImg from "./static/squareToRounds.png";
import flangesImg from "./static/flanges.png";
import cornersImg from "./static/corners.png";
import teeImg from "./static/tee.png";
import offsetsImg from "./static/offsets.png";
import shoesImg from "./static/shoes.png";
import circularBendsImg from "./static/circularBends.png";
import { Container, Header, Card, Image } from "semantic-ui-react";

const Products = () => {
    const products = [
        { key: "ducts", title: "Ducts", image: ductsImg, description: "High-quality galvanized and stainless steel ducts designed for optimal airflow and durability across commercial and industrial applications." },
        { key: "bends", title: "Bends", image: bendsImg, description: "Precision-formed bends for smooth directional changes, minimizing pressure loss and maintaining system efficiency." },
        { key: "squareToRound", title: "Square to Round", image: squareToRoundsImg, description: "Transitions engineered to connect rectangular and circular ductwork while preserving consistent flow characteristics." },
        { key: "flanges", title: "Flanges", image: flangesImg, description: "Robust, easy-to-align flanges enabling fast, secure joints and reliable sealing in demanding environments." },
        { key: "corners", title: "Corners", image: cornersImg, description: "Accurate corner fittings that maintain geometry and structural stability for complex layouts." },
        { key: "tee", title: "Tee", image: teeImg, description: "Balanced tee fittings for branch connections that support efficient distribution and system balance." },
        { key: "offsets", title: "Offsets", image: offsetsImg, description: "Tailored offsets to navigate obstructions while keeping pressure drop and noise to a minimum." },
        { key: "shoes", title: "Shoes", image: shoesImg, description: "Durable take-off shoes designed for quick connections and clean airflow entry into branches." },
        { key: "circularBends", title: "Circular Bends", image: circularBendsImg, description: "Smooth-radius circular bends delivering minimal turbulence and superior performance in round systems." }
    ];

    return (
        <Container className="products">
            <Header textAlign="center" as="h1" content="Products" className="products-name" />
            <Card.Group itemsPerRow={3} stackable doubling className="products-grid">
                {products.map(({ key, title, image, description }) => (
                    <Card key={key} className="products-card" raised>
                        <Image src={image} alt={title} className="products-image" fluid/>
                        <Card.Content textAlign="center">
                            <Card.Header className="products-title">{title}</Card.Header>
                            <Card.Description className="products-desc">{description}</Card.Description>
                        </Card.Content>
                    </Card>
                ))}
            </Card.Group>
        </Container>
    );
};

export default Products;
